<template>
  <div class="sub-menu sticky" v-if="match.batting_order.length > 1">
    <ul>
      <li
        v-for="(teamInn, i) in match.batting_order" :key="i"
        :class="{active: i == matchUserPref.activeInnings}"
        @click="onInningsSelected(i)">
        {{match.teams[teamInn[0]].short_name}}<span
        v-if="match.format.isTest || teamInn[1] === 'superover'">(<span
        v-if="teamInn[1] != 'superover'">Inn {{teamInn[1]}}</span><span
        v-else>Super Over</span>)</span>
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  props: {
    match: Object,
    matchUserPref: Object
  },
  methods: {
    onInningsSelected (i) {
      this.matchUserPref.activeInnings = i
      this.matchUserPref.userSelected = true
      this.$emit('inningsSelected', i)
    }
  }
}
</script>
